

































































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import gql from 'graphql-tag';
import FavoriteBoardsCard from '@/shared/FavoriteBoardsCard.vue';

import * as PAPER_PERMISSIONS_QUERY from 'src/graphql/admin/PaperPermissions.graphql';
import * as FLUTE_PERMISSIONS_QUERY from 'src/graphql/admin/FlutePermissions.graphql';
import * as BOX_STYLE_PERMISSIONS_QUERY from 'src/graphql/admin/BoxStylePermissions.graphql';
import * as PLANT_PERMISSIONS_QUERY from 'src/graphql/admin/PlantPermissions.graphql';
import * as FEATURE_PERMISSIONS_QUERY from 'src/graphql/admin/FeaturePermissions.graphql';

@Component({
  components: {
    FavoriteBoardsCard
  },
  apollo: {
    paper_permissions: {
      query: PAPER_PERMISSIONS_QUERY,
      variables() {
        return {
          group: this.group.name,
        }
      },
      skip() {
        return !this.group;
      },
      fetchPolicy: 'cache-and-network',
    },
    flute_permissions: {
      query: FLUTE_PERMISSIONS_QUERY,
      variables() {
        return {
          group: this.group.name,
        }
      },
      skip() {
        return !this.group;
      },
      fetchPolicy: 'cache-and-network',
    },
    box_style_permissions: {
      query: BOX_STYLE_PERMISSIONS_QUERY,
      variables() {
        return {
          group: this.group.name,
        }
      },
      skip() {
        return !this.group;
      },
      fetchPolicy: 'cache-and-network',
    },
    plant_permissions: {
      query: PLANT_PERMISSIONS_QUERY,
      variables() {
        return {
          group: this.group.name,
        }
      },
      skip() {
        return !this.group;
      },
      fetchPolicy: 'cache-and-network',
    },
    feature_permissions: {
      query: FEATURE_PERMISSIONS_QUERY,
      variables() {
        return {
          group: this.group.name,
        }
      },
      skip() {
        return !this.group;
      },
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class GroupPermissions extends Vue {
  get group() {
    return this.$store.state.currentGroupPermission;
  }

  get groups() {
    return this.$store.state.groups;
  }

  @Watch('groups')
  onGroupsChanged() {
    if (this.group == null) {
      this.$store.state.currentGroupPermission = this.groups[0];
    }
  }

  mounted() {
    if (this.group == null) {
      this.$store.state.currentGroupPermission = this.groups[0];
    } else {
      this.$store.state.currentGroupPermission = this.groups.find( group => group.name == this.group.name );
    }
  }



  paperSearch = '';

  paperHeaders = [
    {
      text: 'Access',
      value: 'access',
      align: 'center',
      sortable: false,
      width: '90',
    },
    {
      text: 'CEPI Name',
      value: 'CEPI_name',
      align: 'center',
    },
  ];

  paper_permissions = [];

  get paper_permissions_with_access() {
    return this.paper_permissions.filter( paper => paper.access );
  }

  onPaperCheckboxChange(item) {
    this.$apollo.mutate({
      mutation: gql`mutation ($groupName: String!, $paperId: Int!, $access: Boolean!) {
        groupSetPaperPermission(groupName: $groupName, paperId: $paperId, access: $access)
      }`,
      variables: {
        groupName: this.group.name,
        paperId: item.paper_id,
        access: !item.access,
      },
      update: (store, {data: { groupSetPaperPermission }}) => {
        let data: any = store.readQuery({
          query: PAPER_PERMISSIONS_QUERY,
          variables: {
            group: this.group.name,
          },
        });

        data.paper_permissions.forEach( paper => {
          if (paper.CEPI_name == item.CEPI_name) {
            paper.access = !item.access;
          }
        });

        store.writeQuery({
          query: PAPER_PERMISSIONS_QUERY,
          variables: {
            group: this.group.name,
          },
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        groupSetPaperPermission: true
      },
    });
  }

  paperSort(items, index, isDescending) {
    const modifier = (isDescending ? -1 : 1);
    return items.sort( (item1, item2) => {
      if (!index)
        return 0;

      const value1 = item1[index];
      const value2 = item2[index];

      if (index === 'CEPI_name') {
        const grammage1 = item1.grammage;
        const grammage2 = item2.grammage;

        const grammageDiff = grammage1 - grammage2;

        if (grammageDiff != 0) {
          return modifier * grammageDiff;
        } else {
          const name1 = item1.name;
          const name2 = item2.name;

          return modifier * name1.toString().localeCompare(name2);
        }
      } else {
        if (isFinite(value1) && isFinite(value2))
          return modifier * (value1 - value2);

        return modifier * value1.toString().localeCompare(value2);
      }
    } );
  }



  fluteSearch = '';

  fluteHeaders = [
    {
      text: 'Access',
      value: 'access',
      align: 'center',
      sortable: false,
      width: '90',
    },
    {
      text: 'Name',
      value: 'name',
      align: 'center',
    },
  ];

  flute_permissions = [];

  get flute_permissions_with_access() {
    return this.flute_permissions.filter( flute => flute.access );
  }

  onFluteCheckboxChange(item) {
    this.$apollo.mutate({
      mutation: gql`mutation ($groupName: String!, $fluteId: Int!, $access: Boolean!) {
        groupSetFlutePermission(groupName: $groupName, fluteId: $fluteId, access: $access)
      }`,
      variables: {
        groupName: this.group.name,
        fluteId: item.flute_id,
        access: !item.access,
      },
      update: (store, {data: { groupSetFlutePermission }}) => {
        let data: any = store.readQuery({
          query: FLUTE_PERMISSIONS_QUERY,
          variables: {
            group: this.group.name,
          },
        });

        data.flute_permissions.forEach( flute => {
          if (flute.flute_id == item.flute_id) {
            flute.access = !item.access;
          }
        });

        store.writeQuery({
          query: FLUTE_PERMISSIONS_QUERY,
          variables: {
            group: this.group.name,
          },
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        groupSetFlutePermission: true
      },
    });
  }



  boxStyleSearch = '';

  boxStyleHeaders = [
    {
      text: 'Access',
      value: 'access',
      align: 'center',
      sortable: false,
      width: '90',
    },
    {
      text: 'Name',
      value: 'name',
      align: 'center',
    },
  ];

  box_style_permissions = [];

  get box_style_permissions_with_access() {
    return this.box_style_permissions.filter( boxStyle => boxStyle.access );
  }

  onBoxStyleCheckboxChange(item) {
    this.$apollo.mutate({
      mutation: gql`mutation ($groupName: String!, $boxStyleId: Int!, $access: Boolean!) {
        groupSetBoxStylePermission(groupName: $groupName, boxStyleId: $boxStyleId, access: $access)
      }`,
      variables: {
        groupName: this.group.name,
        boxStyleId: item.box_style_id,
        access: !item.access,
      },
      update: (store, {data: { groupSetBoxStylePermission }}) => {
        let data: any = store.readQuery({
          query: BOX_STYLE_PERMISSIONS_QUERY,
          variables: {
            group: this.group.name,
          },
        });

        data.box_style_permissions.forEach( boxStyle => {
          if (boxStyle.box_style_id == item.box_style_id) {
            boxStyle.access = !item.access;
          }
        });

        store.writeQuery({
          query: BOX_STYLE_PERMISSIONS_QUERY,
          variables: {
            group: this.group.name,
          },
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        groupSetBoxStylePermission: true
      },
    });
  }



  plantSearch = '';

  plantHeaders = [
    {
      text: 'Access',
      value: 'access',
      align: 'center',
      sortable: false,
      width: '90',
    },
    {
      text: 'Name',
      value: 'name',
      align: 'center',
    },
  ];

  plant_permissions = [];

  get plant_permissions_with_access() {
    return this.plant_permissions.filter( plant => plant.access );
  }

  onPlantCheckboxChange(item) {
    this.$apollo.mutate({
      mutation: gql`mutation ($groupName: String!, $plantId: Int!, $access: Boolean!) {
        groupSetPlantPermission(groupName: $groupName, plantId: $plantId, access: $access)
      }`,
      variables: {
        groupName: this.group.name,
        plantId: item.plant_id,
        access: !item.access,
      },
      update: (store, {data: { groupSetPlantPermission }}) => {
        let data: any = store.readQuery({
          query: PLANT_PERMISSIONS_QUERY,
          variables: {
            group: this.group.name,
          },
        });

        data.plant_permissions.forEach( plant => {
          if (plant.plant_id == item.plant_id) {
            plant.access = !item.access;
          }
        });

        store.writeQuery({
          query: PLANT_PERMISSIONS_QUERY,
          variables: {
            group: this.group.name,
          },
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        groupSetPlantPermission: true
      },
    });
  }



  featureSearch = '';

  featureHeaders = [
    {
      text: 'Access',
      value: 'access',
      align: 'center',
      sortable: false,
      width: '90',
    },
    {
      text: 'Name',
      value: 'name',
      align: 'center',
    },
  ];

  feature_permissions = [];

  get feature_permissions_with_access() {
    return this.feature_permissions.filter( feature => feature.access );
  }

  onFeatureCheckboxChange(item) {
    this.$apollo.mutate({
      mutation: gql`mutation ($groupName: String!, $featureId: Int!, $access: Boolean!) {
        groupSetFeaturePermission(groupName: $groupName, featureId: $featureId, access: $access)
      }`,
      variables: {
        groupName: this.group.name,
        featureId: item.feature_id,
        access: !item.access,
      },
      update: (store, {data: { groupSetFeaturePermission }}) => {
        let data: any = store.readQuery({
          query: FEATURE_PERMISSIONS_QUERY,
          variables: {
            group: this.group.name,
          },
        });

        data.feature_permissions.forEach( feature => {
          if (feature.feature_id == item.feature_id) {
            feature.access = !item.access;
          }
        });

        store.writeQuery({
          query: FEATURE_PERMISSIONS_QUERY,
          variables: {
            group: this.group.name,
          },
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        groupSetFeaturePermission: true
      },
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/GroupPermissions.vue